import { compose, bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { Form } from "antd";
import { get } from 'lodash';

import {
    fetchEvent,
    updateEventSettings
} from '../../eventActions';

import EventAdminCampaignSettingsTransactionsPanel from './EventAdminCampaignSettingsTransactionsPanel';

const mapStateToProps = state => ({
    campaign: get(state, 'campaign.campaign', {}),
    event: get(state, 'Event.event'),
    isUpdateEventSettingsInProgress: get(state, 'Event.isUpdateEventSettingsInProgress', false),
});

const mapDispatchToProps = dispatch => bindActionCreators({
    fetchEvent,
    updateEventSettings
}, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  Form.create(),
)(EventAdminCampaignSettingsTransactionsPanel);
